import { lighten, darken, desaturate } from "polished";
import isMobile from "is-mobile";

const blue = "rgb(13, 165, 223)";
const orange = "rgb(254, 127, 1)";
const black = "rgb(0,0,0)";

export const colors = {
  primary: "#000000",
  primaryHover: lighten(0.1, blue),
  primaryText: "#FFFFFF",
  secondary: "#FFFFFF",
  secondaryHover: lighten(0.3, blue),
  secondaryText: lighten(0.2, black),
  alternate: "#737373",
  alternateHover: "#A6A6A6",
  alternateText: "rgb(168, 166, 190)",
  accent: "rgb(248, 248, 248)",
  secondaryAccent: "rgb(227, 244, 254)",
  alternateAccent: "rgb(70, 64, 88)",
  text: lighten(0.2, black),
  textInvert: "#FFFFFF",
  textPlaceholder: "#DDDDDD",
  link: "#969696",
  linkHover: "#000000",
  background: "#FFFFFF",
  secondaryBackground: "#e8e8e8",
  backgroundInvert: "#000000",
  overlay: "#61618A",
  border: "#000000",
  disabled: "#D9D9D9",
  shadow: "#000000",
  blue,
  orange,
};

export const breakpoints = [32, 48, 64, 80].map((n) => n + "em");

export const space = [0, 4, 8, 16, 24, 32, 64, 128, 164].map(
  (value) => `${((1 / 15) * value).toFixed(3)}rem`
);

/*
export const fontSizes = isMobile()
  ? [10, 11, 14, 18, 21, 24, 32, 40, 48, 64, 72, 96]
  : [8, 9, 11, 14, 16]
*/

export const fontSizes = [10, 12, 14, 18, 21, 24, 32, 40, 48, 64, 72, 96].map(
  (size) => `${((1 / 16) * size).toFixed(3)}rem`
);

const fontCollection = {
  Suisse: {
    fontFamily: `'Suisse', sans-serif`,
    light: 300,
    normal: 400,
    bold: 500,
    fontSize: fontSizes[2],
    lineHeight: 1.5,
    letterSpacing: 0.14,
    color: "#636183",
    textTransform: "uppercase",
  },
};

export const fontWeights = {
  light: 300,
  normal: 400,
  bold: 700,
};

export const textStyles = {
  body: {
    ...fontCollection.Suisse,
    fontWeight: "normal",
  },
  title: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[2],
    fontWeight: "normal",
    lineHeight: 1.4,
  },
  headline: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[4],
    fontWeight: "normal",
    lineHeight: 1.25,
  },
  callout: fontCollection.Suisse,
  subhead: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[3],
    fontWeight: "normal",
  },
  footnote: { ...fontCollection.Suisse, fontSize: 10 },
  label: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[1],
    fontWeight: "normal",
  },
  caption: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[0],
    fontWeight: "normal",
  },
  navigation: {
    ...fontCollection.Suisse,
    fontSize: fontSizes[4],
    fontWeight: "normal",
    lineHeight: 1.25,
  },
  bread: {
    ...fontCollection.Suisse,
    fontWeight: "normal",
    textTransform: "none",
    letterSpacing: 0,
  },
  text: {
    ...fontCollection.Suisse,
    fontWeight: "normal",
    textTransform: "none",
    letterSpacing: 0,
    fontSize: fontSizes[3],
  },
};

export const radii = [0, 4, 8];

export const shadows = ["none", "0 10px 30px 0 rgba(0,0,0,.07)"];

/*
  @media(min-width: 1320px and min-height: 760px) {
    --root-width: 135vh;
  }
  @media (min-width: 1320px && min-height: 760px) {
    --root-width: 1320px;
  }
*/

const maxWidth = `
  --root-width: clamp(65vw, 135vh, 100vw);
  @media(max-width: 920px) and (max-height: 720px) {
    --root-width: 100vw;
  }
  @media(min-width: 1320px) {
    --root-width: clamp(30vw, 135vh, 1320px);
  }
  max-width: var(--root-width);
  
  margin-inline: auto;
`;

export default {
  maxWidth,
  breakpoints,
  space,
  textStyles,
  fontSizes,
  fontWeights,
  colors,
  radii,
  shadows,
};
